import { render } from "./TheVehicleModelsList.vue?vue&type=template&id=32e4c534"
import script from "./TheVehicleModelsList.vue?vue&type=script&lang=js"
export * from "./TheVehicleModelsList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__